<template>
  <div class="container">
    <div class="row">
      <div class="col-12 mb-3 text-center">
        <img src="/images/lms-logo-tagline.png" alt="My Learning Center" />
      </div>
      <div class="col-12 text-center">
        <h1>Enrollment Confirmation</h1>
        <hr />
      </div>

      <template v-if="showDetails">
        <div v-if="!!course" class="col-6">
          <h4 class="text-center text-uppercase mb-4">Course Details</h4>
        </div>
        <div v-else-if="!!event" class="col-6">
          <h4 class="text-center text-uppercase mb-4">Event Details</h4>
          <EventOverview
            class="details-overview"
            :event="event"
            :print="true"
          />
        </div>
        <div v-else-if="!!learningPath" class="col-6">
          <h4 class="text-center text-uppercase mb-4">Learning Path Details</h4>
        </div>
      </template>

      <div
        v-if="!!enrolledBy"
        :class="{ 'col-6': showDetails, 'col-12': !showDetails }"
      >
        <h4 class="text-center text-uppercase mb-3">Enrolled By</h4>
        <div class="details-pane-table details-overview">
          <div class="row mb-2">
            <div class="col-4 col-attribute">Name:</div>
            <div class="col-8 col-value">{{ enrolledBy.name }}</div>
          </div>
          <div class="row mb-2">
            <div class="col-4 col-attribute">Date:</div>
            <div class="col-8 col-value">
              {{ enrollmentDate | moment("M/D/YYYY") }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <hr />
        <h4 class="text-center text-uppercase mb-3">Students Enrolled</h4>
        <div class="enrollment-cart">
          <template v-for="(enrollment, i) in enrollments">
            <hr v-if="i > 0" :key="`hr-${i}`" />
            <CartItemPrint :key="`item-${i}`" :item="enrollment" />
          </template>
        </div>
      </div>

      <div v-if="!!transaction" class="col-12">
        <h5 class="text-uppercase mb-3">Purchase Summary</h5>
        <div class="row" style="font-size: 14px">
          <div class="col-8">Subtotal ({{ enrollments.length }} items)</div>
          <div class="col-4 text-right">{{ subtotal | cost }}</div>
        </div>
        <div
          v-if="!!transaction.coupon_id"
          class="row text-primary"
          style="font-size: 14px"
        >
          <div class="col-8">Coupon</div>
          <div class="col-4 text-right">
            - {{ transaction.coupon_discount | cost }}
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col font-weight-bold">
            <h3>Total</h3>
          </div>
          <div class="col font-weight-bold text-right">
            <h3>* {{ transaction.amount | cost }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CartItemPrint from "./partials/CartItemPrint";
import EventOverview from "components/partials/Events/EventOverview";
export default {
  components: {
    CartItemPrint,
    EventOverview,
  },
  props: {
    enrollments: { type: Array, required: true },
    course: { type: Object, default: () => {} },
    event: { type: Object, default: () => {} },
    learningPath: { type: Object, default: () => {} },
    enrolledBy: { type: Object, default: () => {} },
    enrollmentDate: { type: String, required: true },
    transaction: { type: Object, default: () => {} },
  },
  computed: {
    showDetails() {
      return !!this.course || !!this.event || !!this.learningPath;
    },
    subtotal() {
      var subtotal = 0.0;
      if (!!this.transaction) {
        subtotal =
          this.transaction.amount + (this.transaction.coupon_discount || 0);
      }
      return subtotal;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.print();
    });
  },
};
</script>

<style lang="scss" scoped>
.details-overview {
  font-size: 0.875rem;
}
</style>